import moment from 'moment';

import {pluralize} from '@pb/kit-formatters';

export const getDuration = (isoDuration: string) => {
    const duration = moment.duration(isoDuration);
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();


    const hoursString = hours ? pluralize(`${hours} hour[s]`, hours) : '';
    const minutesString = minutes ? pluralize(`${minutes} minute[s]`, minutes) : '';
    const secondsString = seconds ? pluralize(`${seconds} second[s]`, seconds) : '';

    return [hoursString, minutesString, secondsString].filter(Boolean).join(' ');
};
